<template>
    <div>
         <v-tooltip bottom>
            <v-btn slot="activator"
                    dark
                    icon
                    small
                    flat
                    @click="getDanfe(nota.item._id)"
                    >
                    <v-icon class="material-icons">remove_red_eye</v-icon>
                </v-btn>
            <span>Visualizar DANFE</span>
         </v-tooltip>  
                    <v-dialog @keydown.esc="dialog = false"
                    v-model="dialog"
                    
                    fullscreen
                    :lazy="true"
                    >
                        <v-card>
                            <v-card-title
                            class="headline darkBlue"
                            text-color="white"
                            style="color: white;"
                            
                            >
                            DANFE
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click.native="dialog = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                            </v-card-title>

                            <v-card-text id="tst">
                                <iframe style="width: 100%; height: 90vh;" :src="'data:application/pdf;base64,'+encodeURIComponent(this.nota.item.danfe)" frameborder="0"/> 
                            
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                flat
                                @click="dialog = false"
                            >
                                Fechar
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
    </div>

</template>
<script>
import NfeService from "@/domain/notas/nfe/NfeService";
export default {
  props: ["nota"],
  data() {
    return {
      dialog: false,
      danfeB64: ""
    };
  },
  watch: {},
  computed: {},
  methods: {
    getDanfe: async function(id) {
      if (!this.nota.item.danfe) {
        this.service = new NfeService(this.$http);
        await this.service
          .getDanfe(id)
          .then(danfe => (this.nota.item.danfe = danfe));
      }
      if (this.nota.item.danfe != null) {
        this.dialog = true;
      }
    }
  }
};
</script>
<style>
/* #tst {
  display: inline-block;
} */
#lista {
  padding: 20px;
}
#ico {
  color: grey !important;
  transition: color 1 linear;
}
#ico:hover {
  color: #01579b !important;
}
#ico.v-btn {
  margin: 2px 2px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnVisualizar/btnNFe/BtnNFe.vue